<template>
    <div class="reviewerRank">
        <img class="banner-box" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rank-banner-817.png" alt="">
        <img class="rule-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rank-rule-817.png" alt="" @click="viewRule">
        <div class="title-tab-box">
            <van-tabs animated v-model="activeName" @change="clickTypeTab">
                <van-tab title="全部" name="all"> </van-tab>
                <van-tab title="本店" name="store" v-if="postId == 1 || postId == 4"> </van-tab>
            </van-tabs>
        </div>
        <div class="list-tab-box" id="inner-tab">
            <van-tabs id="card-tab" :active="active" line-width="24px" line-height="4px" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated @change="changeTab">
                <van-tab v-for="item, index in tabList" :key="index" :title="item.name" :name="item.index">
                    <div>
                        <div class="list-title-box flex-between flex-y-center">
                            <div class="Blacks font34 bold">评价累计得分排名</div>
                        </div>
                        <div class="my-list flex-between flex-y-center" v-if="(postId == 5 || postId == 6 || postId == 7 || postId == '1472787652026765731') && type == active">
                            <div class="my-title flex-col flex-y-center">
                                <div class="mb-10">我的排名</div>
                                <div class="Red font30 bold">{{ myRankData.ranking }}</div>
                            </div>
                            <div class="flex-1 flex-between flex-y-center">
                                <img class="header" :src="myRankData.avatar" alt="">
                                <div class="list-info-item flex-1 flex-col flex-between">
                                    <div class="flex-between flex-y-center">
                                        <div class="font28 Blacks">{{ myRankData.name }}</div>
                                        <div class="font28 Red">{{ myRankData.totalVal }}</div>
                                    </div>
                                    <div class="flex-between flex-y-center">
                                        <div class="font28 Greys">{{ myRankData.storeName }}</div>
                                        <!-- <div class="flex-between flex-y-center">
                                            <img class="flower-icon"
                                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/flower-icon.png"
                                                alt="">
                                            <div class="font24 Blacks">{{myRankData.flower}}</div>
                                            <img class="egg-icon"
                                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/egg-icon.png"
                                                alt="">
                                            <div class="font24 Blacks">{{myRankData.egg}}</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="list-box" v-if="list.length != 0">
                            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :loading="loading" :offset="20" :immediate-check="false">
                                <div class="list-item flex-between flex-y-center" v-for="item, index in list" :key="index">
                                    <img class="medal-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rank-1.png" alt="" v-if="item.ranking == 1">
                                    <img class="medal-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rank-2.png" alt="" v-else-if="item.ranking == 2">
                                    <img class="medal-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rank-3.png" alt="" v-else-if="item.ranking == 3">
                                    <div class="ranking font30 bold" v-else>{{ item.ranking }}</div>

                                    <div class="flex-1 flex-between flex-y-center">
                                        <img class="header" :src="item.avatar" alt="">
                                        <div class="list-info-item flex-1 flex-colflex-start">
                                            <div class="flex-between flex-y-center">
                                                <div class="font28 Blacks mb-5 l-h">{{ item.name }}</div>
                                                <div class="font28 Red bold l-h">{{ item.totalVal }}</div>
                                            </div>
                                            <div class="flex-between flex-y-center">
                                                <div class="font28 Greys">{{ item.storeName }}</div>
                                                <!-- <div class="flex-between flex-y-center">
                                                    <img class="flower-icon"
                                                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/flower-icon.png"
                                                        alt="">
                                                    <div class="font24 Blacks">{{item.flower}}</div>
                                                    <img class="egg-icon"
                                                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/egg-icon.png"
                                                        alt="">
                                                    <div class="font24 Blacks">{{item.egg}}</div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </van-list>

                        </div>
                        <div v-else class="empty-box flex flex-col">
                            <div class="empty-main  flex-col">
                                <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" class="empty-icon" alt="" />
                                <div class="empty-txt">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <van-popup class="definition-popup-box" v-model="ruleShow" closeable close-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/close.png">
            <div class="definition-show-box">
                <!-- <div class="definition-head">获奖规则</div> -->
                <div class="definition-head"></div>
                <div class="definition-content">
                    <div class="definition-name-box flex-col">
                        <span class="definition-name">1、评选对象：全国美丽田园直营门店美疗师；</span>
                        <span class="definition-name">2、评选时间：2024.8.8~2024.10.3；</span>
                        <span class="definition-name">3、评选方式：客人来店护理结单后0.5小时内系统自动推送服务评价链接，客人点击评价，系统自动记录；</span>
                        <span class="definition-name">4、获奖前提：美疗师所获评价分值≥30分（即低于 30 分则无现金激励）；</span>
                        <span class="definition-name">5、获奖规则：<span class="pink">每收到1个好评得1分，每收到1个一般得0.5分，每收到1个差评（不满意）得-3分，最终获得多少评价分值，即可获得对应分值奖金（1分=1元现金），同时按美疗师技能等级分组，每组得分TOP可获得加持激励；</span>
                        </span>
                    </div>
                    <img class="medal-list" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rule_new.jpg" alt="">
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'


    export default {
        name: "reviewerRank",
        data() {
            return {
                activeName: "all", //tab
                storeTabIndex: '0',// 门店tab
                loading: false,
                finished: false,
                refreshing: false,
                ruleShow: false,   //定义说明
                page: 1,       // 当前页
                active: 1,
                type: 0,// 我所属的tab
                tabList: [
                    {
                        name: '资深&专家',
                        index: 1
                    },
                    {
                        name: '高级',
                        index: 2
                    },
                    {
                        name: '中级',
                        index: 3
                    },
                    {
                        name: '初级&助理',
                        index: 4
                    },
                ],
                list: [],
                myRankData: {},
                postId: 0
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.onLoad()
        },
        methods: {
            onLoad() {
                if (this.page == 1) {
                    Toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0, // 持续展示 toast
                        loadingType: 'spinner',
                        className: 'toast',
                    });
                }
                this.loading = true
                request({
                    url: `/evaluation/getNewList?type=${this.active}&page=${this.page}&store=${this.storeTabIndex}`,
                    method: "get",
                })
                    .then((res) => {
                        this.list = this.page == 1 ? res.data.list : this.list.concat(res.data.list);
                        this.page += 1;
                        this.myRankData = res.data.empDataDTO
                        this.type = res.data.type
                        if (res.data.list.length < 10) {
                            this.finished = true;
                        }
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.refreshing = false
                        Toast.clear();
                    });
            },
            changeTab(index) {
                this.active = index
                this.page = 1
                // 清空列表数据
                this.finished = false;
                this.loading = true;
                this.list = [];
                this.refreshing = false;
                this.onLoad()
            },
            //查看规则
            viewRule() {
                this.ruleShow = true;
            },
            //查看类型切换
            clickTypeTab() {
                if (this.activeName == "all") {
                    this.storeTabIndex = 0;
                }
                else if (this.activeName == "store") {
                    this.storeTabIndex = 1;
                }
                this.page = 1
                this.list = [];
                this.onLoad();
            },
        },
    };
</script>

<style scoped lang="less">
    .mb-7 {
        margin-bottom: 7px;
    }

    .reviewerRank {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        position: relative;
    }

    .rule-icon {
        width: 136px;
        height: 136px;
        position: fixed;
        right: 0;
        top: 547px;
        z-index: 999;
    }

    .l-h {
        line-height: 40px;
    }

    .list-tab-box {
        padding: 30px 0 0 0;
    }

    .list-title-box {
        padding: 0 30px;
    }

    :deep(#inner-tab .van-tabs .van-tab--active > .van-ellipsis) {
        height: 70px !important;
        line-height: 70px;
        background: #fff !important;
        border-radius: 0 !important;
        color: #35434c !important;
    }

    :deep(#inner-tab .van-tabs__wrap) {
        padding: 0 30px;
    }

    :deep(#inner-tab .van-tabs .van-tabs__line) {
        bottom: -12px;
        background-color: #2fd0d5 !important;
    }

    :deep(#inner-tab .van-tabs .van-tabs__nav) {
        height: 42px;
        padding: 0 !important;
    }

    :deep(#inner-tab .van-tabs .van-tab) {
        flex: inherit;
        margin-right: 60px;
        padding: 0 !important;
    }

    :deep(#inner-tab .van-tabs .van-tab .van-tab__text) {
        max-width: 136px;
        min-width: 53px;
        height: 40px !important;
        line-height: 40px !important;
        font-weight: 400;
        // color: #35434c;
    }

    :deep(#inner-tab .van-tabs .van-tab.van-tab--active .van-tab__text) {
        font-weight: 700;
    }

    .empty-box {
        padding: 40px 30px;
    }

    .empty-main {
        align-items: center;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .empty-icon {
        width: 210px;
        height: 210px;
        margin-top: 40px;
    }

    .banner-box {
        width: 750px;
        height: 480px;
        overflow: hidden;
    }

    .list-box {
        border: 1px solid #fff;
        background-color: #f3f3f3;
    }

    .list-title-box:after {
        content: "";
        width: 100%;
        height: 3px;
        display: block;
        background-color: white;
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .my-list {
        width: 690px;
        height: 150px;
        background: #ffffff;
        box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
        border-radius: 20px;
        padding: 16px 20px;
        margin: 0 auto;
        margin-bottom: 13px;
        margin-top: 40px;
    }

    .list-item {
        height: 142px;
        background: #ffffff;
        padding: 0 50px 0 20px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .my-title {
        width: 50px;
        color: #35434c;
        font-size: 24px;
    }

    .header {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 20px;
        margin-left: 30px;
    }

    .list-info-item {
        height: 80px;

        .flower-icon {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }

        .egg-icon {
            width: 24px;
            height: 22px;
            margin-right: 10px;
            margin-left: 20px;
        }
    }

    .medal-icon {
        width: 49px;
        height: 55px;
    }

    .medal-list {
        width: 550px;
        height: 221px;
        margin-top: 35px;
    }

    .ranking {
        width: 49px;
        text-align: center;
    }

    .definition-popup-box {
        width: 630px;
        min-height: 682px;
        background: #ffffff;
        border-radius: 16px;

        .definition-show-box {
            .definition-head {
                width: 630px;
                height: 116px;
                background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rule-top-817.png) 100% no-repeat;
                background-size: 100% 100%;
                font-size: 36px;
                font-weight: 700;
                color: #35434c;
                text-align: center;
                padding-top: 42px;
            }

            .definition-content {
                padding: 10px 40px 80px 40px;
                height: 556px;
                overflow-y: auto;

                .statistics-color {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: #a3b3d0;
                }

                .member-statistics-name {
                    height: 28px;
                    font-size: 28px;
                    font-weight: 700;
                    color: #35434c;
                    line-height: 28px;
                    margin-left: 10px;
                }

                .statistics-store {
                    height: 36px;
                    font-size: 24px;
                    color: #66757f;
                    line-height: 36px;
                    margin-top: 20px;
                }

                .mt {
                    margin-top: 50px;
                }

                .definition-name-box {
                    margin-top: 20px;
                }

                .definition-name {
                    font-size: 24px;
                    color: #66757f;
                }

                .definition-remark {
                    font-size: 24px;
                    color: #66757f;
                    margin-top: 52px;
                }
            }
        }
    }

    :deep(.van-popup) {
        overflow-y: visible !important;
    }

    :deep(.van-popup__close-icon--top-right) {
        top: 105% !important;
        right: 45% !important;
    }

    :deep(.van-icon__image) {
        width: 56px !important;
        height: 56px !important;
    }

    .pink {
        color: #f45252;
    }

    .title-tab-box {
        padding: 15px 30px 0 30px;

        :deep(.van-tabs__line) {
            display: none;
        }

        :deep(.van-tabs) {
            height: 70px !important;
        }

        :deep(.van-tab) {
            flex: 0 0 27% !important;
            padding: 0 !important;
            height: 70px !important;
            line-height: 70px !important;
            color: #a0acb5;
            font-size: 30px;
            font-weight: normal;
        }

        :deep(.van-tab.van-tab--active) {
            height: 70px !important;
            line-height: 70px;
            background: #2fd0d5 !important;
            border-radius: 35px !important;
            color: #fff !important;
            box-shadow: 4px 10px 30px 0px rgba(55, 219, 224, 0.2);
        }

        :deep(.van-tabs__nav--line) {
            height: 70px !important;
            padding-bottom: 0;
            display: flex;
            justify-content: flex-start;
        }
    }
</style>
